import { errorToast, toast } from "@/v2-ui/toast"
import FeatureDetailsHotfixTexts from "@/v2-backoffice-client/feature/details/FeatureDetailsHotfixTexts"
import { useLayerUpdateMutation } from "@/v2-backoffice-client/layer/update/layer.update.mutation"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"

export type LayerViewDetailsHotfixTextsProps = {
  layer: LayerFragment
}

/** Binds the shared hotfix text form to the layer's runtime update. */
function LayerViewDetailsHotfixTexts(props: LayerViewDetailsHotfixTextsProps) {
  const { layer } = props

  const [updateLayer, updateState] = useLayerUpdateMutation()
  errorToast(updateState.error, { title: "Failed to update layer texts" })

  async function onSave(texts: { name: string; description: string | null }) {
    const result = await updateLayer({
      variables: {
        input: {
          FeatureCode: layer.FeatureCode,
          Name: texts.name,
          Description: texts.description,
        },
      },
    })
    if (result.data) toast({ title: "Layer texts saved to the live runtime." })
  }

  return (
    <FeatureDetailsHotfixTexts
      name={layer.Name ?? ""}
      description={layer.Description ?? ""}
      isSaving={updateState.loading}
      featureCodeLabel="Layers"
      onSave={(texts) => void onSave(texts)}
    />
  )
}

export default LayerViewDetailsHotfixTexts
